module.exports = "img/8.68835e.webp";